<template>
  <div class="wrapper">
    <span class="switch-label">
      {{ offLabel }}
    </span>
    <label class="switch">
      <input type="checkbox" :checked="on" @change="emitStatus($event.target.value)">
      <span class="slider round"></span>
    </label>
    <span class="switch-label">
      {{ onLabel }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'Slider',
  props: {
    on: { type: Boolean, default: false },
    offLabel: { type: String, default: '' },
    onLabel: { type: String, default: '' }
  },
  methods: {
    emitStatus(checkValue) {
      if (checkValue === 'on') {
        this.$emit('change', true);
      } else {
        this.$emit('change', false);
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  padding: 5px 0;
  font-size: .9em;
}

.switch-label {
  padding: 5px;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(40px);
  -ms-transform: translateX(40px);
  transform: translateX(40px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>